import router from '../router'
import store from '../store'

router.afterEach((to) => {
  if (/\/questionnaire\/section/.test(to.path)) {
    const qsUrlList = /section(.*)/.exec(to.path)[1].split('/')
    let percent
    // section
    if (!qsUrlList[1]) {
      percent = (qsUrlList[0] - 1) * 25
    }
    // question
    else {
      const sectionQsMount = {
        1: 20,
        2: 21,
        3: 11,
        4: 8,
      }
      const [s, n] = qsUrlList
      percent = (s - 1) * 25 + (n * 25) / sectionQsMount[s]
    }
    store.commit({
      type: 'changeProgress',
      percent: percent,
    })
  }
})
